import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@mui/styles';



function DropdownRow({
    action,
    text,
    divider=false,
    children
}) {

    const classes = useStyles();
    const Divider = ({children}) => {
        return (
        <div className={classes.container}>
            <div className={classes.border} />
            <span className={classes.content}>
                {children}
            </span>
            <div className={classes.border} />
        </div>
        );
    };

    let ret;
    if (divider) {
        ret = <Divider >{children}</Divider>   
    }
    else {
        ret = <div className="dropdown-list-item" onClick={action}>
                {
                text
                }
            </div>
    }
    return (
        ret
        
    );
}

DropdownRow.propTypes = {
    action: PropTypes.func,
    text: PropTypes.string
}

const useStyles = makeStyles({
   
    container: {
        display: 'flex',
        alignItems: 'center',
        paddingTop: '8px',
        paddingBottom: '8px',
    },
    border: {
        borderBottom: '1px solid lightgrey',
        width: '100%'
    },
    content: {
        padding: '0 10px 0 10px',
        fontSize: '11px',
        whiteSpace: 'nowrap',
        color: '#7C7C7C'
    }

})

export default React.memo(DropdownRow);
